export const isStripeEnabled = (): boolean => {
  return !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
};
